import React, {useContext} from "react";
import styled  from "styled-components";
import { ScrollContext } from "../App";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
display: none;

  @media (min-width: 768px) {
  position: fixed;
  mix-blend-mode: difference;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: 40px;
  margin: 20px 60px;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-optical-sizing: auto;
  font-style: normal;
  color: #bfabcc;
  font-size: 20px;
  z-index: 100;
  a {
    color: white;
    text-decoration: none;
  }
  }


`;


const Nav = () => {
  const { t, i18n } = useTranslation();

  const scroll = useContext(ScrollContext);

  const handleScroll = (e, target) => {
    e.preventDefault();
    scroll.current?.scrollTo(target);
  };
    
  return (
    <Wrapper>
      <a href="#about" onClick={(e) => handleScroll(e, "#about")}>{t("about")}</a>
      <a href="#services" onClick={(e) => handleScroll(e, "#services")}>{t("services")}</a>
      <a href="#work" onClick={(e) => handleScroll(e, "#work")}>{t("work")}</a>
      <a href="#contact" onClick={(e) => handleScroll(e, "#contact")}>{t("contact")}</a>
    </Wrapper>
    
  );
};

export default Nav;
